import { createApp } from 'vue'
import App from './App.vue'
import router from './router/Router';
import { createHead } from '@vueuse/head';
// import VueGoogleMaps from '@fawmi/vue-google-maps'



const app = createApp(App);
const head = createHead();

// app.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyCeU9rLR00dFx60znDnSs0uk4a-AXgE2UQ',
//     libraries: 'places',
//   },
// })

app.use(router);
app.use(head);

app.mount('#app');

